import React from 'react';

const LoadingIndicator = ({loading}) => {

  return (
    <div className='loading-outer-container'>
      {loading && <div className='loading-inner-container' ></div>}
    </div>
  );
};

export default LoadingIndicator;
